import { Row, Col, InputGroup, Button, FormControl, Container } from "react-bootstrap";
import { BsSendCheck,  } from "react-icons/bs";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../App.css";
import HeaderComponent from "./HeaderComponent";
import { useState } from "react";
import { AiOutlineReload } from "react-icons/ai";
import FooterComponent from "./FooterComponent";
import api from "../../services/api";

const SeguimientoQueja = () => {
  document.title = "Seguimiento Denuncia | SIDEC";

  const [error, setError] = useState(null);
  // eslint-disable-next-line
  const [fecha, setFecha] = useState("");  // string (no array)
   // eslint-disable-next-line       
  const [dqueja, setDqueja] = useState(null);      // fecha última atención
  const [visual, setVisual] = useState(false);     // boolean (no array)
  const [data, setData] = useState({});            // objeto queja
  const [searchFolio, setsearchFolio] = useState("");

  const handleInputChange = (e) => setsearchFolio(e.target.value);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  const handleReload = () => {
    setData({});
    setFecha("");
    setDqueja(null);
    setVisual(false);
    setsearchFolio("");
    setError(null);
  };

  // Buscar por folio con orden de seguimientos (último primero)
  const handleFolio = async () => {
    if (!searchFolio) {
      setError("Ingrese un Folio");
      setTimeout(() => setError(""), 2000);
      return;
    }

    setError("");
    setFecha("");
    setData({});
    setDqueja(null);

    try {
      const response = await api.get(`quejas/folio/${searchFolio}/resumido`);
      const quejaData = response.data || {};

      // ordenar seguimientos por fecha desc
      const segs = Array.isArray(quejaData.seguimientos) ? quejaData.seguimientos : [];
      const segsOrdenados = [...segs].sort(
        (a, b) => new Date(b?.fechaActualizacion || 0) - new Date(a?.fechaActualizacion || 0)
      );
      const ultimoSeg = segsOrdenados[0] || null;

      setFecha(quejaData.fecha || "");
      setData({ ...quejaData, seguimientos: segsOrdenados });
      setDqueja(ultimoSeg?.fechaActualizacion || null);
      setVisual(true);
    } catch (error) {
      const errorMessage =
        error.response?.status === 404 ? "El Folio no existe" : "Error al consultar el folio";
      setError(errorMessage);
      setTimeout(() => setError(""), 2000);
      setVisual(false);
    }
  };

  // Para que Enter dispare BUSCAR y no envíe el form “raro”
  const handleSubmit = async (e) => {
    e.preventDefault();
    await handleFolio();
  };

  return (
    <div
      style={{
        //backgroundImage:"url(https://www.veracruz.gob.mx/proteccioncivil/wp-content/uploads/sites/5/2024/12/459029599_938750401627993_9216811163148847696_n.jpg)",
        backgroundImage: "url(/background2.jpeg)",
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat"
      }}
    >
      <HeaderComponent />
      <br />
      <Container style={{ flex: 1 }}>
      <div
        className="container"
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.90)",
          borderRadius: "10px",
          padding: "20px",
          marginBottom: "20px",
          boxShadow: "0 0 20px rgba(0, 0, 0, 0.1)",
          //maxHeight: "calc(100vh - 200px)", // Ajusta según necesidades
          //overflowY: "auto", // Habilita scroll solo para el formulario
        }}
      >
        <h3 className="text-center text-contrast" style={{ color: "black" }}>
            {" "}
            SEGUIMIENTO A QUEJAS Y DENUNCIAS CIUDADANA
          </h3>

        <br />

        <form onSubmit={handleSubmit}>
          <Row className="justify-content-center">
            <Col>
              <div className="form-group mb-4">
                <label className="form-label">
                  <b>Ingrese su número de Folio</b>
                </label>
                <InputGroup className="input-group-append">
                  <FormControl
                    type="text"
                    className="form-control"
                    id="searchOficio"
                    name="searchOficio"
                    placeholder="QUEJA-202904-00005"
                    aria-label="QUEJA-202904-00005"
                    value={searchFolio}
                    onChange={handleInputChange}
                  />

                  <Button variant="success" id="button-addon" type="submit">
                    <BsSendCheck /> Buscar
                  </Button>
                  <Button variant="light" id="button-addon" type="button" onClick={handleReload}>
                    <AiOutlineReload />
                  </Button>
                </InputGroup>
              </div>
            </Col>
          </Row>

          <div className="col-md-8">
            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}

            <hr />
            {visual && (
              <>
                <h1>Detalle de la queja</h1>
                <p>Enviada el: {formatDate(data.fecha)}</p>

                {data.atendido=== true ? (
                  <div>
                    <p>
                      Atendida el: {formatDate(data?.seguimiento.fechaActualizacion || "--")}
                    </p>
                    <p>
                      Método de Seguimiento: {data?.seguimiento.metodo || "—"}
                    </p>

                    
                  </div>
                ) : (
                  <p>En seguimiento (aún no atendida)</p>
                )}
              </>
            )}
          </div>
        </form>
      </div>
      </Container>
      <FooterComponent />
    </div>
  );
};

export default SeguimientoQueja;
